import { render, staticRenderFns } from "./ordera.vue?vue&type=template&id=46a549d4&scoped=true&"
import script from "./ordera.vue?vue&type=script&lang=js&"
export * from "./ordera.vue?vue&type=script&lang=js&"
import style0 from "./ordera.vue?vue&type=style&index=0&id=46a549d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a549d4",
  null
  
)

export default component.exports